module.exports = __webpack_public_path__ + "static/media/grzejniki.a2d66127.svg";